import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaSms, FaMapMarkerAlt, FaBell, FaFolder, FaCamera, FaShieldAlt } from 'react-icons/fa';
import TopBar from './component/TopBar';

const permissions = [
  { icon: <FaSms />, title: 'SMS', desc: 'We collect SMS data to determine your cash flow, credit, income, OTP verification, and spending pattern.' },
  { icon: <FaMapMarkerAlt />, title: 'Location', desc: 'Used for fraud prevention, address verification, and document acceptance.' },
  { icon: <FaBell />, title: 'Push Notification', desc: 'To send updates, offers, repayment due dates, and financial news.' },
  { icon: <FaFolder />, title: 'Storage', desc: 'Required for smooth onboarding and access to our products and services.' },
  { icon: <FaCamera />, title: 'Camera', desc: 'Required for borrower verification via selfie and liveness check.' },
  { icon: <FaShieldAlt />, title: 'Meta Data', desc: 'To ensure device trustworthiness and mitigate risks.' },
];

const Permission = () => {
  const [agreed, setAgreed] = useState(false);
  const [error, setError] = useState('');

  const navigate = useNavigate();
  const location = useLocation();
  const id = new URLSearchParams(location.search).get('id');

  const handleSubmit = () => {
    if (!agreed) { setError('Please accept the permissions to continue.'); return; }
    navigate(`/PanVerifecation?id=${id}`);
  };

  return (
    <div className="app-page">
      <TopBar title="Permissions" backPath={`/Otp?id=${id}`} />

      <div className="app-content">
        <div className="app-card">
          <p className="section-title">Why we need access</p>
          <p style={{ fontSize: 13, color: '#666', lineHeight: 1.6, marginBottom: 16 }}>
            Ujjwal Srijan and its partners request permission to collect information from your device to ensure transparency and prevent fraud.
          </p>

          {permissions.map((p, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 14, marginBottom: 16 }}>
              <div style={{ fontSize: 22, color: '#1d2e77', marginTop: 2, minWidth: 24 }}>{p.icon}</div>
              <div>
                <p style={{ fontWeight: 700, fontSize: 14, color: '#1d2e77', marginBottom: 2 }}>{p.title}</p>
                <p style={{ fontSize: 12, color: '#666', lineHeight: 1.5, marginBottom: 0 }}>{p.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="app-card">
          <div className="check-row">
            <input type="checkbox" checked={agreed} onChange={e => { setAgreed(e.target.checked); setError(''); }} />
            <label>I agree and accept consent for the above mentioned permissions.</label>
          </div>
          {error && <p style={{ color: '#e53935', fontSize: 13, marginTop: 8 }}>{error}</p>}
        </div>

        <button className="btn-primary-app" onClick={handleSubmit}>
          Proceed
        </button>
      </div>
    </div>
  );
};

export default Permission;
